import './PropheciesCanvas.scss';
import Grid from '../../components/game/Grid';
import PlayerHelper from '../../players/PlayerHelper';
import React, {useState} from 'react';
import {Prophecies, PropheciesAction} from "../../common-build/games/Prophecies";
import {CanvasProps} from "../../common-build/stuff/CanvasProps";


/**
 * Example squareData:
 *   {
 *     owner: 1, // 0, 1, or null (automatic)
 *     value: 3, // positive integer, or 0 ("X")
 *   }
 * Example action:
 * {
 *   owner: 1, row: 1, col: 1, value: 1,
 * },
 */


const PropheciesCanvas = (props: CanvasProps<Prophecies, PropheciesAction>) => {
  const {gameState, gameSettings} = props.game;

  const game = new Prophecies(gameState, gameSettings, 2)

  const grid = gameState.grid;
  const numRows = grid.length;
  const numCols = grid[0].length;
  const activePlayerIndex = gameState.activePlayerIndex;
  const activePlayer = activePlayerIndex === null ? null : gameSettings.players[activePlayerIndex];

  const [targetSquare, setTargetSquare] = useState<[number, number] | null>(null);

  const onAction = value => {
    if (targetSquare === null) return
    if (gameState.activePlayerIndex === null) return
    let [row, col] = targetSquare
    props.onChooseMove({owner: gameState.activePlayerIndex, row, col, value});
    setTargetSquare(null);
  };

  const isSquareSelected = (row, col) => {
    return targetSquare && targetSquare[0] === row && targetSquare[1] === col;
  };

  const {rowWinners, colWinners} = game.calculateScores(gameState.grid)

  const renderNumberSelector = () => {
    if (!targetSquare) {
      return;
    }
    let max = Math.max(numRows, numCols);
    if (gameSettings.xProphecies) {
      max--;
    }
    let allNumbers = new Array(max).fill(null).map((v, i) => i + 1);
    let validNumbers = game.calculateValidNumbers(...targetSquare);
    return (
      <div className='numberSelector shadow'>
        {allNumbers.map(v => (
          <div
              className={`option ${validNumbers.has(v) ? 'valid' : ''}`}
              key={v}
              onClick={() => validNumbers.has(v) && onAction(v)}>
            {v}
          </div>
        ))}
        <div className='option valid' onClick={() => onAction(0)}>X</div>
        <div className='option valid' onClick={() => setTargetSquare(null)}>back</div>
      </div>
    );
  };

  const renderSquareValue = squareData => {
    let value = squareData && squareData.value;
    if (!Number.isInteger(value)) {
      return null;
    }
    return value === 0 ? 'X' : value;
  };

  const getSquareStyle = squareData => {
    if (squareData && squareData.owner === null) {
      return null;
    }
    let playerIndex = Number.isInteger(squareData && squareData.owner) ?
        squareData.owner : gameState.activePlayerIndex;
    return PlayerHelper.getStyleClass(gameSettings.players[playerIndex]);
  };

  const isHighlighted = (squareData, i: number, j: number) => {
    let lastMoves = gameState.lastMove;
    return lastMoves &&
        lastMoves.some(move => move.row === i && move.col === j) || false;
  };

  const isTouchable = squareData => {
    return (props.isLocal || (activePlayer && PlayerHelper.isOwnedByMe(activePlayer))) && (squareData || {}).owner === undefined;
  };

  const onTouch = (data, i, j) => {
    setTargetSquare(isSquareSelected(i, j) ? null : [i, j]);
  };

  const renderSquareOverlay = (squareData, i, j) => {
    let isRowWinner = rowWinners[i] && rowWinners[i] === squareData.value;
    let isColWinner = colWinners[j] && colWinners[j] === squareData.value;
    let winner = <div className='winner overlay' />;
    let doubleWinner = <div className='doubleWinner overlay' />;
    return (
      <div className='overlay'>
        {(isRowWinner || isColWinner) ? winner : null}
        {(isRowWinner && isColWinner) ? doubleWinner : null}
        {isSquareSelected(i, j) ? renderNumberSelector() : null}
      </div>
    );
  };

  return (
    <div className='PropheciesCanvas'>
      <Grid
          // @ts-ignore
          className='grid'
          grid={gameState.grid}
          squareStyle={getSquareStyle}
          isHighlighted={isHighlighted}
          isTouchable={isTouchable}
          onTouch={onTouch}
          renderSquareValue={renderSquareValue}
          renderSquareOverlay={renderSquareOverlay} />
    </div>
  );
};


export default PropheciesCanvas;
